import React, { useEffect, useState } from "react";

import { Box, IconButton, MenuItem, Select, Typography } from "@material-ui/core";
import CancelRounded from "@material-ui/icons/CancelRounded";
import { CustomInputType } from "@remar/shared/dist/components/CustomInput/customInput.model";
import AddButton from "@remar/shared/dist/ui/Buttons/AddButton";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import { _emit } from "store/features/notifications/notifications.slice";

import theme from "theme/default";

import CommonQuestionFields from "./CommonQuestionFields";
import { GroupContainer, InputContainer, RemoveGapWrapper, CustomInput as StyledInput, useStyles } from "./styles";

import { useTestOnlyQuestionStyles } from "../../CreateLesson/TestOnlyQuestions/testOnlyQuestions.styles";

export const ClozeDropDownQuestion = ({
	createGroupAnswerOptionItem,
	createQuestionGap,
	getFullState,
	removeGap,
	removeGapOption,
	removeQuestionAttachment,
	setStateValue,
	updateCorrectFlag,
	uploadQuestionMaterial,
	validateForm,
	formName = "addNewQuestionForm",
	statePath = ""
}) => {
	const dispatch = useDispatch();

	const fullStatePath = statePath ? `inputs.${statePath}` : "inputs";

	const classes = { ...useTestOnlyQuestionStyles(), ...useStyles() };
	const questionData = get(useSelector(getFullState), `${formName}.${fullStatePath}`);
	const [gapIndex, setGapIndex] = useState(0);
	const { groups, description, _expanded, attachments, endOfQuestionSummary, mainImageKey } = questionData;

	const defaultCustomInputOptions = { _emit, dispatch, setStateValue, validateForm };

	const notDeletedGaps = groups.filter(({ deleted }) => !deleted.value).length;

	useEffect(() => {
		if (groups.length === 0) {
			dispatch(createQuestionGap({ start: true, statePath, formName }));
		}
	}, [groups.length]);

	return (
		<CommonQuestionFields
			description={description}
			attachments={attachments}
			endOfQuestionSummary={endOfQuestionSummary}
			mainImageKey={mainImageKey}
			statePath={statePath}
			setStateValue={setStateValue}
			expanded={_expanded?.value}
			validateForm={validateForm}
			removeQuestionAttachment={removeQuestionAttachment}
			uploadQuestionMaterial={uploadQuestionMaterial}
		>
			<Typography className={classes.addOptionHeader}>SENTENCE</Typography>
			{groups.map(
				({ id, text, answerOptions, deleted }, groupIndex) =>
					!deleted.value && (
						<GroupContainer key={id.value} error={text.error}>
							<Box width="calc(70% - 20px)" mr={1}>
								<StyledInput mr={2} theme={theme} options={{ ...defaultCustomInputOptions, inputData: text }} />
							</Box>

							<InputContainer>
								{groupIndex < groups.length - 1 ? (
									<StyledInput
										mr={2}
										theme={theme}
										inputProps={{
											onChange: ({ target: { value } }) =>
												dispatch(updateCorrectFlag({ groupIndex, answerOptionIndex: value, statePath }))
										}}
										options={{
											...defaultCustomInputOptions,
											inputData: {
												type: CustomInputType.Select,
												defaultValue: "",
												value: (index => (index === -1 ? "" : index))(
													answerOptions?.findIndex(({ isCorrect }) => isCorrect.value)
												),
												selectOptions: answerOptions
													.filter(({ deleted }) => !deleted.value)
													.map(({ text }, value) => ({ text: text.value, value })),
												pristine: true
											}
										}}
									/>
								) : (
									" "
								)}
							</InputContainer>
							<RemoveGapWrapper>
								{groupIndex < groups.length - 1 && notDeletedGaps > 2 ? (
									<IconButton
										size="small"
										onClick={() => {
											dispatch(removeGap({ formName, statePath, gapIndex: groupIndex }));
											if (groupIndex === gapIndex) {
												setGapIndex(groups.findIndex(({ deleted }, index) => !deleted.value && index !== groupIndex));
											}
										}}
									>
										<CancelRounded color="disabled" />
									</IconButton>
								) : (
									" "
								)}
							</RemoveGapWrapper>
						</GroupContainer>
					)
			)}
			<Box mt={2}>
				<AddButton
					onClick={() => {
						dispatch(
							createQuestionGap({
								statePath,
								formName
							})
						);
					}}
					label={"Add Gap"}
				/>
			</Box>
			{groups.length > 0 && (
				<>
					<Select
						className={classes.select}
						disableUnderline
						value={gapIndex}
						onChange={({ target: { value } }) => setGapIndex(value as number)}
					>
						{groups
							.map(({ deleted }, realIndex) => ({ realIndex, deleted: deleted.value }))
							.filter(({ deleted }) => !deleted)
							.slice(0, -1)
							.map(({ realIndex }, index) => (
								<MenuItem key={realIndex} value={realIndex}>
									Word choices for gap {index + 1}
								</MenuItem>
							))}
					</Select>
					{groups[gapIndex]?.answerOptions.map(
						({ id, text, deleted }, answerOptionIndex) =>
							!deleted?.value && (
								<GroupContainer key={id.value} display="flex" alignItems="center" error={text.error}>
									<StyledInput mr={2} theme={theme} options={{ ...defaultCustomInputOptions, inputData: text }} />
									<Box flex="0" ml={1}>
										<IconButton
											size="small"
											onClick={() => dispatch(removeGapOption({ gapIndex, answerOptionIndex, statePath }))}
										>
											<CancelRounded color="disabled" />
										</IconButton>
									</Box>
								</GroupContainer>
							)
					)}
					<Box mt={2}>
						<AddButton
							onClick={() => {
								dispatch(createGroupAnswerOptionItem({ index: gapIndex, statePath }));
							}}
							label={"Add Option"}
						/>
					</Box>
				</>
			)}
		</CommonQuestionFields>
	);
};
